
import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { migrateAssistantData } from '@/utils/assistantMigration';
import { toast } from 'sonner';

export const useAssistantMigration = () => {
  const { user } = useAuth();
  const [isMigrating, setIsMigrating] = useState(false);
  const [migrationComplete, setMigrationComplete] = useState(false);

  useEffect(() => {
    const checkAndMigrate = async () => {
      if (!user?.id) return;
      
      // Check if we've already migrated by looking for a flag in localStorage
      const migrationFlag = localStorage.getItem(`assistant_migration_${user.id}`);
      if (migrationFlag) {
        setMigrationComplete(true);
        return;
      }
      
      setIsMigrating(true);
      try {
        const success = await migrateAssistantData(user.id);
        
        if (success) {
          // Store flag in localStorage to avoid checking again
          localStorage.setItem(`assistant_migration_${user.id}`, 'true');
          setMigrationComplete(true);
          console.log('AI Assistant migration check completed successfully');
          // We'll no longer show toasts since we're just checking, not migrating
        } else {
          console.error('There was an issue checking AI Assistant data');
          // Don't show error toasts to users as this is just a background check
        }
      } catch (error) {
        console.error('Migration check failed:', error);
        // Don't show error toasts to users
      } finally {
        setIsMigrating(false);
      }
    };
    
    checkAndMigrate();
  }, [user?.id]);

  return { isMigrating, migrationComplete };
};
